
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bookings/floorplans",
      function () {
        return require("private-next-pages/bookings/floorplans.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bookings/floorplans"])
      });
    }
  